import { useEffect } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { formatPercentage, formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { Theme, createStyles, lighten, makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Button,
} from '@roc/ui';


const tableClasses = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(4),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
    },
    tableRowFont: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      lineHeight: '143%',
      letterSpacing: '1.25px',
      textTransform: 'uppercase'
    },
    tableRowData: {
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '153%',
    },
    header: {
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: '1.25px',
      backgroundColor: 'transparent',
      borderBottom: 'solid 1px',
      padding: '16px',
      textTransform: 'uppercase',
      '& div': {
        textAlign: 'center'
      }
    },
    customizeButton: {
      borderRadius: '6px',
      fontSize: '14px',
      marginRight: '-15px',
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      backgroundColor: 'white',
      width: '175px',
      letterSpacing: '1.25px',
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '32px',
      paddingRight: '32px',
      height: '40px',
      textTransform: 'uppercase'
    },
    anyOtherRowClass: {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    bold: {
      fontWeight: 'bold'
    }
  }),
);

export const QuoteDataTable = observer(({ rows }: {
  rows: {
    label: string,
    value: string
  }[]
}) => {
  const theme = useTheme();
  const tableClass = tableClasses();

  return (<Box mt={2} display={'flex'}>
    <TableContainer>
      <Table size='small'>
        <TableBody>
          {
            rows?.map((row, i) => {
              return (
                <TableRow key={row.label} className={i % 2 !== 0 ? tableClass.anyOtherRowClass : ''}>
                  <TableCell className={`${tableClass.tableRowFont}`} component="th" scope="row" align="left">
                    {row.label}
                  </TableCell>
                  <TableCell className={tableClass.tableRowData} component="th" scope="row" align="right">
                    {row.value}
                  </TableCell>
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    </TableContainer>
  </Box>)
})